import * as loginFormNames from "./loginFormNames";

export const loginInitialValues = {
  [loginFormNames.LOGIN_USERNAME_FORM_NAME]: "",
  [loginFormNames.LOGIN_SECRET_FORM_NAME]: "",
};
